import ChatPreview from '@/components/ChatPreview'
import { getAnswer } from '@/utils/onboardingStorage'
import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

export default function SplashPage() {
  const { t } = useTranslation()

  // Personalize the chat preview by gender: lead with the most likely match.
  const gender = getAnswer('gender')?.answer_key
  const companion =
    gender === 'female'
      ? { name: 'Liam', color: '#7D8A99' }
      : { name: 'Mia', color: '#A8937D' }

  const messages = [
    {
      from: 'companion' as const,
      text: t('pages.onboarding.splash.chatMessage1'),
    },
    { from: 'user' as const, text: t('pages.onboarding.splash.chatMessage2') },
    {
      from: 'companion' as const,
      text: t('pages.onboarding.splash.chatMessage3'),
    },
  ]

  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center gap-8 text-center">
        <ChatPreview
          messages={messages}
          companionName={companion.name}
          color={companion.color}
        />

        <h1 className="text-primary max-w-xl font-serif text-[2rem] leading-[1.2] font-normal">
          {t('pages.onboarding.splash.title')}
        </h1>
        <p className="text-muted -mt-3 max-w-[320px] text-[0.95rem] leading-relaxed">
          {t('pages.onboarding.splash.subtitle')}
        </p>

        <p className="max-w-[300px] text-[0.72rem] text-[#A09A90]">
          {t('pages.onboarding.splash.socialProof')}
        </p>
      </div>

      <Form method="post" className="shrink-0">
        <ContinueButton />
      </Form>
    </PageLayout>
  )
}
